'use client'

import { useSearchParams } from 'next/navigation'
import { useCallback, useEffect } from 'react'

import { getEncryptedCookies } from '@/libs/actions/encrypt-decrypt-cookies'
import setPartnerIdCookie from '@/libs/actions/set-partner-id-cookie'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { setCurrentUserPartnerIdNonIntegration } from '@/libs/store/slice/user-slice'

const HandlePartnerNonIntegrationCookie = () => {
  const searchParams = useSearchParams()
  const partnerId = searchParams.get('partner_id')
  const dispatch = useAppDispatch()

  const checkPartnerId = useCallback(async () => {
    const encryptedCookie = await getEncryptedCookies()

    if (partnerId) {
      setPartnerIdCookie(partnerId, false, true)
      dispatch(setCurrentUserPartnerIdNonIntegration(partnerId))

      return
    }

    if (encryptedCookie?.isPnir && encryptedCookie?.partnerId) {
      dispatch(setCurrentUserPartnerIdNonIntegration(encryptedCookie?.partnerId))
    }
  }, [dispatch, partnerId])

  useEffect(() => {
    checkPartnerId()
  }, [dispatch, partnerId, checkPartnerId])

  return null
}

export default HandlePartnerNonIntegrationCookie
